module.exports = __webpack_public_path__ + "static/media/fivehundredgoals.ef5d4187.jpg";